import React, { useState } from 'react';
import { BASE_URL } from '../config/api'; // Assuming BASE_URL is correctly defined in your config/api.js
import { useNavigate } from 'react-router-dom';

const AddSubCategory = () => {
    const [name, setName] = useState('');
    const [image, setImage] = useState(null);
    const [error, setError] = useState('');
    const navigate = useNavigate();

    // Handle form submission
    const handleSubmit = async (event) => {
        event.preventDefault();
        setError('');

        if (!name || !image) {
            setError('Name and Image are required');
            return;
        }

        // Create a FormData object to handle file upload
        const formData = new FormData();
        formData.append('name', name);
        formData.append('image', image);

        try {
            const response = await fetch(`${BASE_URL}subcategories`, {
                method: 'POST',
                body: formData,
            });

            const data = await response.json();
            if (data.status === 1) {
                alert(data.message);
                navigate('/SubCategoryList'); // Redirect to the subcategory list page after successful creation
            } else {
                setError(data.message);
            }
        } catch (error) {
            console.error('Error creating subcategory:', error);
            setError('An error occurred while creating the subcategory');
        }
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Add Subcategory</h3>
                        </div>
                    </div>
                </div>
            </div>

            {/* Add Subcategory Form */}
            <section className="section">
                <div className="row" id="basic-table">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <h4>Add New Subcategory</h4>
                            </div>
                            <div className="card-body">
                                {error && <div className="alert alert-danger">{error}</div>}
                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label htmlFor="name" className="form-label">Name</label>
                                        <input
                                            type="text"
                                            id="name"
                                            className="form-control"
                                            placeholder="Enter subcategory name"
                                            value={name}
                                            onChange={(e) => setName(e.target.value)}
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="image" className="form-label">Image</label>
                                        <input
                                            type="file"
                                            id="image"
                                            className="form-control"
                                            onChange={(e) => setImage(e.target.files[0])}
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <button type="submit" className="btn btn-primary">Add Subcategory</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default AddSubCategory;
